import { render, staticRenderFns } from "./proshopposition.vue?vue&type=template&id=26b23de2&scoped=true&"
import script from "./proshopposition.vue?vue&type=script&lang=js&"
export * from "./proshopposition.vue?vue&type=script&lang=js&"
import style0 from "./proshopposition.vue?vue&type=style&index=0&id=26b23de2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b23de2",
  null
  
)

export default component.exports